import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { OTTERFOLIO_THEME } from "./theme";

interface Props {
  totalValueCents: number;
  returnCents: number;
  returnPercent: number;
  categoryTotals?: {
    felsCents: number;
    raketeCents: number;
    uncategorizedCents: number;
  };
}

function fmtCents(cents: number): string {
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(cents / 100);
}

function fmtPercent(pct: number): string {
  return new Intl.NumberFormat("de-DE", {
    style: "percent",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(pct);
}

export function TopBar({ totalValueCents, returnCents, returnPercent, categoryTotals }: Props) {
  const { t } = useTranslation();
  const isPositive = returnCents >= 0;
  const changeColor = isPositive ? OTTERFOLIO_THEME.primary : OTTERFOLIO_THEME.highlight;
  const arrow = isPositive ? "▲" : "▼";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingBottom: 12,
        borderBottom: `1px solid ${OTTERFOLIO_THEME.cardBorder}`,
      }}
    >
      <Link
        to="/"
        aria-label={t("otterfolio.backToDashboard", { defaultValue: "Zurück zum Dashboard" })}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 14,
          textDecoration: "none",
          color: "inherit",
        }}
      >
        <img
          src="/otterfolio/otter-logo.png"
          width={80}
          height={80}
          alt=""
          style={{
            borderRadius: 10,
            objectFit: "cover",
            boxShadow: `0 0 0 1px ${OTTERFOLIO_THEME.cardBorder}`,
          }}
        />
        <div>
          <div style={{ fontWeight: 800, fontSize: 18, color: OTTERFOLIO_THEME.text }}>
            {t("otterfolio.brand")}
          </div>
          <div
            style={{
              fontSize: 11,
              color: OTTERFOLIO_THEME.primary,
              textTransform: "uppercase",
              letterSpacing: 1,
            }}
          >
            {t("otterfolio.tagline")}
          </div>
        </div>
      </Link>
      <div style={{ textAlign: "right" }}>
        <div
          style={{
            fontSize: 10,
            color: OTTERFOLIO_THEME.textMuted,
            textTransform: "uppercase",
            letterSpacing: 1,
          }}
        >
          {t("otterfolio.totalValueLabel")}
        </div>
        <div
          style={{
            fontSize: 30,
            fontWeight: 800,
            color: OTTERFOLIO_THEME.text,
            letterSpacing: -0.5,
          }}
        >
          {fmtCents(totalValueCents)}
        </div>
        <div style={{ fontSize: 13, color: changeColor, fontWeight: 700 }}>
          {arrow} {fmtCents(Math.abs(returnCents))} · {fmtPercent(returnPercent)}{" "}
          {t("otterfolio.sinceStart")}
        </div>
        {categoryTotals && (categoryTotals.felsCents > 0 || categoryTotals.raketeCents > 0) && (
          <div style={{ fontSize: 11, color: OTTERFOLIO_THEME.textMuted, marginTop: 2 }}>
            🪨 {fmtCents(categoryTotals.felsCents)} · 🚀 {fmtCents(categoryTotals.raketeCents)}
          </div>
        )}
      </div>
    </div>
  );
}
